import React, { useState } from "react";
import {useNavigate} from "react-router-dom";

import flag from "./assets/imgs/main-logo.png";
import {purposeData} from "./utils/purposeData";
import {useTranslation} from "react-i18next";
import classes from "./About.module.css";
import {universities} from "../home/BaseData";

export const About = () => {
    const {t} = useTranslation();
    const currentLang = localStorage.getItem("i18nextLng");
    const navigate = useNavigate();
    const page_id_test = 0;
    const [showFullText, setShowFullText] = useState(false);

    const historyText = t("historyofAlmazar");
    const truncatedText = historyText.substring(0, 500) + "...";

    return (
        <div className={classes["mainContainer"]}>
            <div className={classes["container"]}>
                <div data-aos="fade-up" className={classes["main"]}>
                    <div className={classes["left"]}>
                        <div className={classes["flag"]}>
                            <img className={classes["flag_img"]} src={flag}/>
                        </div>
                    </div>
                    <div className={classes["right"]}>
                        <h1 className={classes["header"]}>{t("about_university")}</h1>
                        <p className={classes["about_olmazor"]}>
                            {showFullText ? historyText : truncatedText}
                        </p>
                        <button 
                            className={classes["readMoreBtn"]}
                            onClick={() => setShowFullText(!showFullText)}
                        >
                            {showFullText ? t("show_less") : t("read_more")}
                        </button>
                    </div>
                </div>
                <div data-aos="fade-up" className={classes["maqsad"]}>
                    <div className={classes["cards"]}>
                        <div className={classes["first_"]}>
                            {purposeData.map((value, index) => {
                                return (
                                    <div
                                        data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                                        key={value.id}
                                        className={classes["card1"]}
                                    >
                                        <div className={classes["h3_dv"]}>
                                            <div className={classes["dv"]}></div>
                                            <h3 className={classes["title"]}>
                                                {value[currentLang].title}
                                            </h3>
                                        </div>
                                        <p className={classes["descr"]}>
                                            {value[currentLang].descr}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.sidebar}>
                <h3>{t("university")}</h3>
                <ul>
                    {universities.map((item, index) => (
                        (index === page_id_test ? (
                            <li className={classes.active} onClick={() => navigate(item.path)}>
                                <span className={classes.icon}>
                                    ▶
                                </span>
                                {t(item.text)}
                            </li>
                        ) : (
                            <li onClick={() => navigate(item.path)}>
                                {t(item.text)}
                            </li>
                        ))
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default About;
